module.exports = __webpack_public_path__ + "static/media/wavm8s-016-klahrk.f99d74d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-016-klahrk.mp3
// module id = 2aYX
// module chunks = 0